import { Link as RouterLink, Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// components
import Logo from '../components/Logo';
import Footer from '../components/Footer';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <HeaderStyle>
        {/* <RouterLink to="/"> */}
        <Logo />
        {/* </RouterLink> */}
      </HeaderStyle>
      <Outlet />
      <Box sx={{ position: 'absolute', width: '100%', bottom: 0, left: 0, textAlign: 'center' }}>
        <Footer />
      </Box>
    </>
  );
}
